var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("my-asidebar", { attrs: { "active-tab": "sail" } }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "dashboard-area" },
        [
          _c("top-bar"),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard-content-wrap" }, [
            _c(
              "div",
              {
                staticClass:
                  "dashboard-bread dashboard--bread dashboard-bread-2",
              },
              [
                _c("div", { staticClass: "container-fluid" }, [
                  _c("div", { staticClass: "row align-items-center" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-lg-6" }, [
                      _c("div", { staticClass: "breadcrumb-list text-right" }, [
                        _c("ul", { staticClass: "list-items" }, [
                          _c("li", [
                            _c(
                              "a",
                              {
                                staticClass: "text-white",
                                attrs: { href: _vm.basePath },
                              },
                              [_vm._v("Anasayfa")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [_vm._v("Sefer")]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dashboard-main-content" }, [
              _c("div", { staticClass: "container-fluid" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-12" }, [
                    _vm.sailList !== null
                      ? _c(
                          "div",
                          { staticClass: "form-box" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-end mr-4",
                              },
                              [
                                _c("sail-batch-update-modal", {
                                  attrs: { "sail-list": _vm.sailList },
                                }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "theme-btn theme-btn-small",
                                    attrs: {
                                      href: "javascript:void(0)",
                                      href: _vm.basePath + "/sails/new",
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "la la-plus mr-1" }),
                                    _vm._v(
                                      "\n                    Sefer Yarat\n                  "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("sail-list", {
                              attrs: { "sail-list": _vm.sailList },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.sailList === null
                ? _c("div", {
                    staticClass: "loader col-lg-12 mt-5",
                    attrs: { id: "loader" },
                  })
                : _vm._e(),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-6" }, [
      _c("div", { staticClass: "breadcrumb-content" }, [
        _c("div", { staticClass: "section-heading" }, [
          _c("h2", { staticClass: "sec__title font-size-30 text-white" }, [
            _vm._v("Sefer"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }